import React, {useState, useEffect, useContext} from "react";
import "./Blog.scss";
import BlogCard from "../../components/blogCard/BlogCard";
import {blogSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
export default function Blogs() {
  const {isDark} = useContext(StyleContext);
  //const [mediumBlogs, setMediumBlogs] = useState([]);
  /*function setMediumBlogsFunction(array) {
    setMediumBlogs(array);
  }
  //Medium API returns blogs' content in HTML format. Below function extracts blogs' text content within paragraph tags
  function extractTextContent(html) {
    return typeof html === "string"
      ? html
          .split(/<\/p>/i)
          .map(part => part.split(/<p[^>]*>/i).pop())
          .filter(el => el.trim().length > 0)
          .map(el => el.replace(/<\/?[^>]+(>|$)/g, "").trim())
          .join(" ")
      : NaN;
  }
  useEffect(() => {
    if (blogSection.displayMediumBlogs === "true") {
      const getProfileData = () => {
        fetch("/blogs.json")
          .then(result => {
            if (result.ok) {
              return result.json();
            }
          })
          .then(response => {
            setMediumBlogsFunction(response.items);
          })
          .catch(function (error) {
            console.error(
              `${error} (because of this error Blogs section could not be displayed. Blogs section has reverted to default)`
            );
            setMediumBlogsFunction("Error");
            blogSection.displayMediumBlogs = "false";
          });
      };
      getProfileData();
    }
  }, []);*/

  const mediumBlogs = [
    {
      link: "https://medium.com/@bradyllewis/leveraging-user-feedback-loops-to-enhance-ai-product-development-4726126ea26e",
      title: "Leveraging User Feedback Loops to Enhance AI Product Development",
      content: "As artificial intelligence (AI) continues to integrate deeper into digital products, organizations face mounting pressure to deliver intuitive, accurate, and ethically sound AI-driven solutions. A key factor distinguishing successful AI deployments from those falling short is the effectiveness of user feedback loops."
    },
    {
      link: "https://medium.com/@bradyllewis/ai-powered-go-to-market-gtm-strategies-for-new-digital-products-1b40335038a2",
      title: "AI-Powered Go-to-Market (GTM) Strategies for New Digital Products",
      content: "Artificial intelligence (AI) has rapidly transitioned from futuristic innovation to an essential pillar supporting today’s digital product launches. Businesses looking to compete effectively in an increasingly sophisticated marketplace are recognizing that traditional go-to-market (GTM) strategies fall short in the age of AI-driven insights."
    },
    {
      link: "https://medium.com/@bradyllewis/prompt-alchemy-how-stacking-ai-prompts-turns-base-responses-into-gold-6fde7ac36e08",
      title: "Prompt Alchemy: How Stacking AI Prompts Turns Base Responses into Gold",
      content: "Ask a basic question, get a basic answer. That’s the AI equivalent of “garbage in, garbage out” that frustrates many first-time users of tools like ChatGPT or Claude. But here’s what separates the AI power users from the dabblers: they’re not asking single questions... they’re orchestrating sophisticated conversations through something I call prompt stacking."
    },
    {
      link: "https://medium.com/@bradyllewis/why-were-building-flow-orchestra-the-ai-platform-that-makes-workflow-automation-human-4ae8c9a32854",
      title: "Why We’re Building Flow Orchestra: The AI Platform That Makes Workflow Automation Human",
      content: "The idea hit me during a late-night debugging session, staring at dozens of open tabs and half-finished automation scripts. There had to be a better way to connect these digital dots. That moment became the seed for Flow Orchestra, and today, I’m excited to announce we’re opening our waitlist."
    },
    {
      link: "https://medium.com/@bradyllewis/beyond-random-prompting-the-5-step-framework-for-ai-content-mastery-18c1de100132",
      title: "Beyond Random Prompting: The 5-Step Framework for AI Content Mastery",
      content: "Ever notice how some organizations seem to effortlessly integrate AI into their content operations, while others flail around with disconnected experiments that go nowhere? The difference isn’t access to better AI tools or bigger budgets — it’s having a systematic approach that transforms AI from a shiny toy into a strategic asset."
    },
    {
      link: "https://medium.com/@bradyllewis/the-pillar-satellite-method-how-to-create-21-pieces-of-content-from-one-source-c396dda1b5ef",
      title: "The Pillar & Satellite Method: How to Create 21 Pieces of Content from One Source",
      content: "Content creation can feel like an endless treadmill. Just when you’ve published that blog post you’ve been working on for days, it’s time to create something new for social media, your newsletter, and every other platform where your audience lives."
    },
    {
      link: "https://medium.com/@bradyllewis/word-to-your-marketing-director-social-media-strategies-that-slap-68632df12fbb",
      title: "Word to Your Marketing Director: Social Media Strategies That Slap",
      content: "In a world cluttered with content, social media strategies need to resonate, ignite conversations, and build genuine connections. Let’s dive into some dynamic strategies that not only engage but also stick with your audience like a catchy beat. Get ready for a ride through storytelling, visuals, engagement tactics, and more!"
    },
    {
      link: "https://medium.com/@bradyllewis/raise-up-your-roi-from-bootstrapped-to-booked-out-989a89bf4232",
      title: "Raise Up Your ROI: From Bootstrapped to Booked Out",
      content: "Are you stuck in the whirlwind of bootstrapping your business? Do your resources feel like a pair of worn-out running shoes? It’s time to flip the script and raise your ROI. Transforming from bootstrapped to fully booked is not just a dream; it’s an achievable goal."
    }
  ]

  if (!blogSection.display) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="blogs">
        <div className="blog-header">
          <h1 className="blog-header-text">{blogSection.title}</h1>
          <p
            className={
              isDark ? "dark-mode blog-subtitle" : "subTitle blog-subtitle"
            }
          >
            {blogSection.subtitle}
          </p>
        </div>
        <div className="blog-main-div">
          <div className="blog-text-div">
            {blogSection.displayMediumBlogs !== "true" ||
            mediumBlogs === "Error"
              ? blogSection.blogs.map((blog, i) => {
                  return (
                    <BlogCard
                      key={i}
                      isDark={isDark}
                      blog={{
                        url: blog.url,
                        image: blog.image,
                        title: blog.title,
                        description: blog.description
                      }}
                    />
                  );
                })
              : mediumBlogs.map((blog, i) => {
                  return (
                    <BlogCard
                      key={i}
                      isDark={isDark}
                      blog={{
                        url: blog.link,
                        title: blog.title,
                        description: blog.content
                      }}
                    />
                  );
                })}
          </div>
        </div>
      </div>
    </Fade>
  );
}
